export default {
  "navigation": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact"])},
    "career": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Career"])},
    "sites": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sites"])},
    "secondarySites": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Secondary sites"])},
    "headOfficeLeinfeldenEchterdingen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Head Office of the Novatec Consulting GmbH"])},
    "headOfficeGranada": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Head Office of the NOVATEC Software Engineering España S.L."])}
  }
}